import React, { createContext, useContext, useState, ReactNode } from 'react';
import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';

interface InsuranceTypeContextValue {
  insuranceType: InsuranceType;
  setInsuranceType: (type: InsuranceType) => void;
}

const InsuranceTypeContext = createContext<InsuranceTypeContextValue | null>(null);

interface InsuranceTypeProviderProps {
  children: ReactNode;
}

// Centralized provider for managing and updating the selected insurance type(primary, secondary).
export const InsuranceTypeProvider: React.FC<InsuranceTypeProviderProps> = ({ children }) => {
  const [insuranceType, setInsuranceType] = useState<InsuranceType>(InsuranceType.INSURANCE_TYPE_PRIMARY);

  return (
    <InsuranceTypeContext.Provider value={{ insuranceType, setInsuranceType }}>
      {children}
    </InsuranceTypeContext.Provider>
  );
};

export const useInsuranceType = (): InsuranceTypeContextValue => {
  const context = useContext(InsuranceTypeContext);
  if (!context) {
    throw new Error('useInsuranceType must be used within an InsuranceTypeProvider');
  }
  return context;
};
